<template>
  <a-modal
    wrap-class-name="payee-bank-choose"
    :visible="visible"
    :width="920"
    :title="$t('pages_pay_242')"
    :mask-closable="false"
    @cancel="$emit('update:visible', false)"
    @ok="handleSubmit"
  >
    <a-form class="search-form ant-round-form">
      <a-form-item :label="$t('pages_pay_087')" style="margin-left: 8px">
        <a-input
          v-model:value="searchQuery.param"
          allow-clear
          style="width: 218px"
          :placeholder="$t('pages_pay_370')"
          @pressEnter="loadBankList(1)"
        />
      </a-form-item>
      <a-button
        type="primary"
        shape="round"
        style="margin-left: 24px"
        @click="loadBankList(1)"
      >{{ $t('common_text_063') }}</a-button>
    </a-form>
    <div class="table-part">
      <a-table
        :loading="loading"
        :pagination="false"
        :custom-header-row="() => { return {class: 'my-table-tr'}}"
        :columns="columns"
        :data-source="banks"
        :row-selection="{
          onChange: tableSelect,
          selectedRowKeys: selectedRowKeys,
          type: 'radio',
          columnTitle: $t('common_text_001'),
          columnWidth: 120
        }"
      />
      <table-page
        :total="total"
        :page-opts="searchQuery"
        @update-page="updatePage"
      />
    </div>
  </a-modal>
</template>
<script>
import { reactive, toRefs } from 'vue'
import TablePage from '@/components/table-page'
import { _pay } from '@/api'
import i18n from '@/locale'
export default {
  name: 'BankChoose',
  components: {
    'table-page': TablePage
  },
  props: {
    visible: {
      type: Boolean,
      default: () => { return false }
    }
  },
  setup (props, ctx) {
    const state = reactive({
      loading: false,
      total: 0,
      searchQuery: {
        pageNum: 1,
        pageSize: 10,
        param: ''
      },
      bankObj: {
        bankLineNo: '',
        bankName: ''
      },
      selectedRowKeys: [],
      banks: [],
      columns: [
        { key: 'index', dataIndex: 'index', title: i18n.global.t('pages_pay_105') },
        { key: 'bankName', dataIndex: 'bankName', title: i18n.global.t('pages_pay_087') },
        { key: 'bankLineNo', dataIndex: 'bankLineNo', title: i18n.global.t('pages_pay_247') }
      ]
    })

    const tableSelect = (selectedRowKeys, record) => {
      state.selectedRowKeys = selectedRowKeys
      state.bankObj.bankLineNo = record[0].bankLineNo
      state.bankObj.bankName = record[0].bankName
    }

    const updatePage = (page, pageSize) => {
      state.searchQuery.pageNum = page
      state.searchQuery.pageSize = pageSize
      loadBankList()
    }

    const handleSubmit = () => {
      ctx.emit('bankChange', state.bankObj)
      ctx.emit('update:visible', false)
    }

    const loadBankList = async (pageNum) => {
      state.loading = true
      if (pageNum) state.searchQuery.pageNum = pageNum
      const query = {
        pageNo: state.searchQuery.pageNum,
        pageSize: state.searchQuery.pageSize,
        request: state.searchQuery
      }
      const res = await _pay.getBankList(query)
      if (res.data.succ) {
        state.banks = res.data.data.results.map((item, index) => {
          return Object.assign({}, item, {
            index: index + 1,
            key: item.bankName
          })
        })
        state.total = res.data.data.totalRecord
      }
      state.loading = false
    }

    return {
      updatePage,
      loadBankList,
      tableSelect,
      handleSubmit,
      ...toRefs(state)
    }
  }
}
</script>
<style lang="less" scoped>
.payee-bank-choose {
  .search-form {
    margin-top: 0;
  }
}
</style>

